var React = require('react');

function ChevronDownColor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.75 22.125L29.5 36.875L44.25 22.125","stroke":"#000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronDownColor.defaultProps = {"viewBox":"0 0 59 59","fill":"none"};

module.exports = ChevronDownColor;

ChevronDownColor.default = ChevronDownColor;
